export default {
    props: {
        valueAxisValueAxisItemAxisCrossingValue: {
            type: [Object, Date, Array],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.axisCrossingValue'
        }, 
        valueAxisValueAxisItemColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.color'
        }, 
        valueAxisValueAxisItemLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.background'
        }, 
        valueAxisValueAxisItemLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.border.color'
        }, 
        valueAxisValueAxisItemLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.border.dashType'
        }, 
        valueAxisValueAxisItemLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.border.width'
        }, 
        valueAxisValueAxisItemLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.color'
        }, 
        valueAxisValueAxisItemLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.font'
        }, 
        valueAxisValueAxisItemLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.format'
        }, 
        valueAxisValueAxisItemLabelsMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.margin'
        }, 
        valueAxisValueAxisItemLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.mirror'
        }, 
        valueAxisValueAxisItemLabelsPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.padding'
        }, 
        valueAxisValueAxisItemLabelsRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.rotation'
        }, 
        valueAxisValueAxisItemLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.skip'
        }, 
        valueAxisValueAxisItemLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.step'
        }, 
        valueAxisValueAxisItemLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.template'
        }, 
        valueAxisValueAxisItemLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.visible'
        }, 
        valueAxisValueAxisItemLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.color'
        }, 
        valueAxisValueAxisItemLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.dashType'
        }, 
        valueAxisValueAxisItemLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.visible'
        }, 
        valueAxisValueAxisItemLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.width'
        }, 
        valueAxisValueAxisItemMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.color'
        }, 
        valueAxisValueAxisItemMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.visible'
        }, 
        valueAxisValueAxisItemMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.width'
        }, 
        valueAxisValueAxisItemMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.step'
        }, 
        valueAxisValueAxisItemMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.skip'
        }, 
        valueAxisValueAxisItemMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.size'
        }, 
        valueAxisValueAxisItemMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.visible'
        }, 
        valueAxisValueAxisItemMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.color'
        }, 
        valueAxisValueAxisItemMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.width'
        }, 
        valueAxisValueAxisItemMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.step'
        }, 
        valueAxisValueAxisItemMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.skip'
        }, 
        valueAxisValueAxisItemMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorUnit'
        }, 
        valueAxisValueAxisItemMax: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.max'
        }, 
        valueAxisValueAxisItemMin: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.min'
        }, 
        valueAxisValueAxisItemMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.color'
        }, 
        valueAxisValueAxisItemMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.dashType'
        }, 
        valueAxisValueAxisItemMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.visible'
        }, 
        valueAxisValueAxisItemMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.width'
        }, 
        valueAxisValueAxisItemMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.step'
        }, 
        valueAxisValueAxisItemMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.skip'
        }, 
        valueAxisValueAxisItemMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.size'
        }, 
        valueAxisValueAxisItemMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.color'
        }, 
        valueAxisValueAxisItemMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.width'
        }, 
        valueAxisValueAxisItemMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.visible'
        }, 
        valueAxisValueAxisItemMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.step'
        }, 
        valueAxisValueAxisItemMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.skip'
        }, 
        valueAxisValueAxisItemMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorUnit'
        }, 
        valueAxisValueAxisItemName: {
            type: Object,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.name'
        }, 
        valueAxisValueAxisItemNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.narrowRange'
        }, 
        valueAxisValueAxisItemPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.plotBands'
        },         valueAxisValueAxisItemReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.reverse'
        }, 
        valueAxisValueAxisItemTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.background'
        }, 
        valueAxisValueAxisItemTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.border.color'
        }, 
        valueAxisValueAxisItemTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.border.dashType'
        }, 
        valueAxisValueAxisItemTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.border.width'
        }, 
        valueAxisValueAxisItemTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.color'
        }, 
        valueAxisValueAxisItemTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.font'
        }, 
        valueAxisValueAxisItemTitleMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.margin'
        }, 
        valueAxisValueAxisItemTitlePadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.padding'
        }, 
        valueAxisValueAxisItemTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.position'
        }, 
        valueAxisValueAxisItemTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.rotation'
        }, 
        valueAxisValueAxisItemTitleText: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.text'
        }, 
        valueAxisValueAxisItemTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.visible'
        }, 
        valueAxisValueAxisItemVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.visible'
        }, 
        valueAxisValueAxisItemCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.color'
        }, 
        valueAxisValueAxisItemCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.width'
        }, 
        valueAxisValueAxisItemCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.opacity'
        }, 
        valueAxisValueAxisItemCrosshairDashType: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.dashType'
        }, 
        valueAxisValueAxisItemCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.visible'
        }, 
        valueAxisValueAxisItemCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.background'
        }, 
        valueAxisValueAxisItemCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.border.color'
        }, 
        valueAxisValueAxisItemCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.border.width'
        }, 
        valueAxisValueAxisItemCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.color'
        }, 
        valueAxisValueAxisItemCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.font'
        }, 
        valueAxisValueAxisItemCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.format'
        }, 
        valueAxisValueAxisItemCrosshairTooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.padding'
        }, 
        valueAxisValueAxisItemCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.template'
        }, 
        valueAxisValueAxisItemCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.visible'
        }, 
        valueAxisValueAxisItemNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.position'
        }, 
        valueAxisValueAxisItemNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.background'
        }, 
        valueAxisValueAxisItemNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.border.color'
        }, 
        valueAxisValueAxisItemNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.border.width'
        }, 
        valueAxisValueAxisItemNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.size'
        }, 
        valueAxisValueAxisItemNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.type'
        }, 
        valueAxisValueAxisItemNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.visible'
        }, 
        valueAxisValueAxisItemNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.background'
        }, 
        valueAxisValueAxisItemNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.color'
        }, 
        valueAxisValueAxisItemNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.dashType'
        }, 
        valueAxisValueAxisItemNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.width'
        }, 
        valueAxisValueAxisItemNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.color'
        }, 
        valueAxisValueAxisItemNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.font'
        }, 
        valueAxisValueAxisItemNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.template'
        }, 
        valueAxisValueAxisItemNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.visible'
        }, 
        valueAxisValueAxisItemNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.rotation'
        }, 
        valueAxisValueAxisItemNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.format'
        }, 
        valueAxisValueAxisItemNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.position'
        }, 
        valueAxisValueAxisItemNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.line.width'
        }, 
        valueAxisValueAxisItemNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.line.color'
        }, 
        valueAxisValueAxisItemNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.line.length'
        }, 
        valueAxisValueAxisItemNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.data'
        }    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/ValueAxis.js